// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chipItem__jvSGD {
  height: 32px;
  padding-right: 10px;
  padding-left: 12px;
  display: flex;
  align-items: center;
  border-radius: 10px;
  background: var(--tables-secondary-row-sub-title-surface);
}

.chipItemHidden__CND3h {
  display: none;
}

.chipItemDisabled__OVq0E {
  opacity: 0.38;
  pointer-events: none;
}

.chipItemName__mL06V {
  font-size: 10px;
  font-weight: 500;
  line-height: 11px;
  text-transform: uppercase;
  color: var(--tables-primary-row-text-main);
}

.chipItemExtra__dFZOR {
  font-weight: 400;
  color: var(--tables-primary-row-text-additional);
  text-transform: capitalize;
  margin-left: 15px;
}

.chipItemDeleteIcon__SYSE_ {
  margin-left: 6px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./../src/components/common/FacilityTreeBlock/components/ChipItem/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yDAAA;AAzEF;;AA4EA;EACE,aAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,oBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,0CAAA;AAzEF;;AA4EA;EACE,gBAAA;EACA,gDAAA;EACA,0BAAA;EACA,iBAAA;AAzEF;;AA4EA;EACE,gBAAA;EACA,eAAA;AAzEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.chipItem {\n  height: 32px;\n  padding-right: 10px;\n  padding-left: 12px;\n  display: flex;\n  align-items: center;\n  border-radius: 10px;\n  background: var(--tables-secondary-row-sub-title-surface);\n}\n\n.chipItemHidden {\n  display: none;\n}\n\n.chipItemDisabled {\n  opacity: 0.38;\n  pointer-events: none;\n}\n\n.chipItemName {\n  font-size: 10px;\n  font-weight: 500;\n  line-height: 11px;\n  text-transform: uppercase;\n  color: var(--tables-primary-row-text-main);\n}\n\n.chipItemExtra {\n  font-weight: 400;\n  color: var(--tables-primary-row-text-additional);\n  text-transform: capitalize;\n  margin-left: 15px;\n}\n\n.chipItemDeleteIcon {\n  margin-left: 6px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chipItem": `chipItem__jvSGD`,
	"chipItemHidden": `chipItemHidden__CND3h`,
	"chipItemDisabled": `chipItemDisabled__OVq0E`,
	"chipItemName": `chipItemName__mL06V`,
	"chipItemExtra": `chipItemExtra__dFZOR`,
	"chipItemDeleteIcon": `chipItemDeleteIcon__SYSE_`
};
module.exports = ___CSS_LOADER_EXPORT___;
